module.exports = __webpack_public_path__ + "static/media/ButtonEnterSize12.8f307c63.png";